import React from "react";
import { Badge, Tooltip, Group } from "@mantine/core";

type AdminPermissionScope = 'department' | 'program' | 'user';

type PermissionScopeBadgeProps = {
  permission: 'attendance.admin' | 'employees.adminLeave';
  scope?: AdminPermissionScope;
  onEdit?: () => void;
};

const SCOPE_LABELS: Record<AdminPermissionScope, { label: string; description: string }> = {
  department: {
    label: 'Department',
    description: 'Can manage users in their department',
  },
  program: {
    label: 'Program',
    description: 'Can manage users in their program',
  },
  user: {
    label: 'All Affiliations',
    description: 'Can manage all users from departments and programs they are assigned to',
  },
};

const SCOPE_COLORS: Record<AdminPermissionScope, string> = {
  department: 'blue',
  program: 'cyan',
  user: 'red',
};

export function PermissionScopeBadge({
  permission,
  scope,
  onEdit,
}: PermissionScopeBadgeProps) {
  if (!scope) {
    return (
      <Badge variant="outline" color="gray" size="sm">
        No Scope
      </Badge>
    );
  }

  const scopeInfo = SCOPE_LABELS[scope];

  return (
    <Tooltip
      label={`${scopeInfo.label}: ${scopeInfo.description}${onEdit ? ' (Click to edit)' : ''}`}
      withArrow
    >
      <Badge
        variant="filled"
        color={SCOPE_COLORS[scope]}
        size="sm"
        style={{ cursor: onEdit ? 'pointer' : 'default' }}
        onClick={onEdit}
      >
        {scopeInfo.label}
      </Badge>
    </Tooltip>
  );
}
